const t=4;export{t as default};
//# sourceMappingURL=spacing.js.map
